import styled from 'styled-components';
import { TextButton } from '../../styles/theme-styled';
import Button from '@gjc/classi-react-commons/ClassiButton';

export const FolderTitleContainer = styled.div`
    display: flex;
    width: 100%;
    padding: 20px 0;
    height: fit-content;
    align-items: center;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: normal;
    }
`;

export const FolderTitle = styled.h2`
    height: fit-content;
    font-size: 18px;
`;

// Botão para baixar o folder
export const FolderButton = styled(TextButton)`
    && {
        color: #288394;
        margin: 0 10px;
        text-decoration: underline;
        height: fit-content;
        align-self: center;
        text-transform: none;
        font-weight: normal;

        @media (max-width: 768px) {
            display: none;
        }
    }
`;

export const FolderButtonMobile = styled(Button)`
    display: none;

    @media (max-width: 768px) {
        display: block;
        margin: 10px 0;
        width: 100%;
    }
`;

export const FolderPreviewContainer = styled.div`
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 1);
    width: 450px;
    padding: 10px;

    @media (max-width: 1150px) {
        display: none;
    }
`;
